export default "__VITE_ASSET__Z7aa8YZZmLrMI4USVJZnAw__"